// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2708": "ae255472","4950": "b54c7902","5700": "e8c03e14","5919": "a7dee1d7",}[chunkId] + ".css"
}